<template>
  <v-container fill-height>
    <v-card class="mx-auto" min-width="100%" height="100%">
      <v-card-title class="headline"></v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <!--<v-row justify="center" class="display-2">パスワード変更</v-row>-->
        <v-row class="text-center" justify="center">
          <!-- 2024.11.29 kouta.noborisaka 三井化学（市原工場）:絞り込みでEnterキー入力時にサブミット実行しないように「@submit.prevent」を追加 -->
          <v-form v-model="valid" ref="form" lazy-validation @submit.prevent>
            <v-alert v-if="message != ''" color="blue" text>{{
              this.message
            }}</v-alert>
            <v-alert v-if="error != ''" color="red" text>{{
              this.error
            }}</v-alert>
            <v-col cols="50">
              <v-text-field
                label="新しいメールアドレス"
                v-model="email"
                :counter="64"
                :rules="[GlobalRules.required, GlobalRules.email]"
                required
                prepend-icon="mdi-email"
              ></v-text-field>
            </v-col>
            <v-col cols="50" v-if="send">
              <v-text-field
                label="認証コード"
                v-model="authcode"
                :counter="6"
                maxlength="6"
                :rules="[GlobalRules.required, GlobalRules.authcode]"
                required
                prepend-icon="mdi-account-check"
              ></v-text-field>
            </v-col>
            <v-card-actions>
              <v-btn
                color="blue"
                outlined
                block
                :disabled="!valid"
                v-if="!send"
                @click="updateUserInfo()"
                >認証コード送信</v-btn
              >
              <v-btn
                color="blue"
                outlined
                block
                :disabled="!valid"
                v-if="send"
                @click="verifyEmail(authcode)"
                >認証</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "UserChangeMailAddress",
  data: () => ({
    valid: false,
    error: "",
    message: "",
    email: "",
    tmpEmail: "",
    authcode: "",
    send: false,
  }),

  methods: {
    //cognito上のメールアドレスを変更（未検証）
    changeEmail(email) {
      //this.updateUserInfo()
      this.$cognito
        .updateEmailAddress(email)
        .then((result) => {
          //eslint-disable-line
          //console.log("成功")
          //console.log({ result })
          this.message = "認証コードを送信しました。";
          this.send = true;
          this.error = "";
        })
        .catch((err) => {
          // console.log(err);
          if (err.code == "NetworkError") {
            this.error = "ネットワークに接続してください";
          } else if (err.code == "LimitExceededException") {
            this.error = "しばらく時間をあけてください";
          } else {
            this.error =
              "認証コードを送信できませんでした。入力内容を確認してください。";
          }
          this.message = "";
          this.putRequest(
            "/api/Users/" + this.$store.getters.getUserId + "/" + this.tmpEmail,
            null,
            this.$store.getters.getUserToken
          ).then((resp) => {
            //eslint-disable-line
            //console.log(resp)
          });
        });
    },

    //cognito上のメールアドレスを検証
    verifyEmail(authcode) {
      this.$cognito
        .verifyAttribute(authcode)
        .then((result) => {
          //eslint-disable-line
          //console.log("成功")
          //console.log({ result })
          this.message = "メールアドレスを変更しました。";
          this.send = true;
          this.error = "";
          // セッション情報にメールアドレスを再セット
          this.$store.commit("setMailAddress", this.email.trim());
        })
        .catch((err) => {
          // console.log(err);
          if (err.code == "NetworkError") {
            this.error = "ネットワークに接続してください";
          } else if (err.code == "LimitExceededException") {
            this.error = "しばらく時間をあけてください";
          } else if (err.code == "CodeMismatchException") {
            this.error = "認証コードに誤りがあります";
          } else {
            this.error =
              "メールアドレスを変更できませんでした。入力内容を確認してください。";
          }
          this.message = "";
        });
    },

    //DBのメールアドレスを更新
    updateUserInfo() {
      this.getEmail();
      // 現在のメールアドレスと入力のメールアドレスを比較する
      if (this.$store.getters.getMailAddress.trim() === this.email.trim()) {
        this.error =
          "変更前のメールアドレスと同じです。内容を確認してください。";
        return;
      }

      // 利用者情報更新
      this.putRequest(
        "/api/Users/" + this.$store.getters.getUserId + "/" + this.email,
        null,
        this.$store.getters.getUserToken
      ).then((resp) => {
        //console.log(resp)
        if (resp == "OK") {
          this.changeEmail(this.email); //DB更新成功時にcognito上の変更を行う
        } else {
          this.error = "変更できません。入力内容を確認してください。";
        }
      });
    },

    //現在のメールアドレスを保持
    getEmail() {
      this.getRequest(
        "/api/Users/" + this.$store.getters.getUserId,
        null,
        this.$store.getters.getUserToken
      ).then((seq) => {
        this.tmpEmail =
          seq.mail_address == null ? "sample@xxx.xxx" : seq.mail_address; //DB更新失敗時のため、メールアドレスを保持しておく
      });
    },
  },
};
</script>
